import styled, { css } from 'styled-components';

import colors from '../../styles/colors';

import variants from './variants';

const Tag = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  white-space: nowrap;
  box-sizing: border-box;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  border-radius: 25px;
  text-transform: none;

  ${({ $variant }) => {
    switch ($variant) {
      case variants.SUCCESS:
        return css`
            background: ${colors.shades.success5};
            color: ${colors.shades.secondary8};
            border-color: ${colors.shades.success4};
        `;
      case variants.WARNING:
        return css`
            background: ${colors.shades.primary5};
            color: ${colors.shades.secondary8};
            border-color: ${colors.shades.primary1};
        `;
      case variants.DANGER:
        return css`
            background: ${colors.shades.danger4};
            color: ${colors.shades.secondary8};
            border-color: ${colors.shades.danger1};
        `;
      default:
        return css`
          background: ${colors.shades.gamma12};
          color: ${colors.shades.secondary8};
          border-color: ${colors.shades.gamma13};
        `;
    }
  }}
`;

export {
  Tag,
};
